<template>

    <b-row>

        <b-col>

            <b-card
                header="Text Message Log"
                header-text-variant="white"
                header-bg-variant="info">

                <b-row class="mb-2">

                    <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                        <date-picker
                            v-model=" start_date "
                            placeholder="Start Date"
                            class="f-1">
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                            v-model=" end_date "
                            placeholder="End Date"
                            class="f-1">
                        </date-picker>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <transition mode="out-in" name="slide-fade">

                            <user-role-search-dropdown v-if=" current_filter_type == 'provider' " type="provider" v-model=" user_id "></user-role-search-dropdown>
                            <user-role-search-dropdown v-if=" current_filter_type == 'claimant' " type="claimant" v-model=" user_id "></user-role-search-dropdown>
                        </transition>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <carrier-dropdown v-model=" ltc_carrier_id "></carrier-dropdown>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <b-select name="special_filter" id="special_filter" v-model=" special_filter ">

                            <option value="">-- Show All --</option>
                            <option value="errors">With Errors</option>
                            <option value="no_user">No User</option>
                        </b-select>
                    </b-col>
                </b-row>
                <b-row class="mb-3">

                    <b-col sm="12" class="d-flex align-items-center justify-content-end">

                        <b-button variant="primary" @click=" changeFilterType() " class="mr-2">{{ filterTypeButtonText }}</b-button>
                        <b-button variant="info" @click=" loadTable() ">Generate</b-button>
                    </b-col>
                </b-row>

                <div class="table-responsive">

                    <b-table bordered striped hover show-empty
                        :items=" items "
                        :fields=" fields "
                        :current-page=" currentPage "
                        :per-page=" 0 "
                        :sort-by.sync=" sortBy "
                        :sort-desc.sync=" sortDesc "
                        :busy=" loading "
                    >

                        <template v-slot:cell(recipient)="row">

                            <a v-if=" row.item.user_id " :href=" `/business/${row.item.user.role_type}s/${row.item.user_id}#textthread` " target="_blank">{{ row.item.recipient }}</a>
                            <p v-else class="mb-0">-- none found --</p>
                        </template>
                        <template v-slot:cell(actions)="row">

                            <b-btn v-b-tooltip.hover title="View Message" class="mr-1" size="sm" variant="info" @click=" selectText( row.item )"><i class="fa fa-eye"></i></b-btn>
                        </template>
                    </b-table>
                </div>

                <b-row>

                    <b-col lg="6" >

                        <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                    </b-col>
                    <b-col lg="6" class="text-right">

                        {{ paginationText }}
                    </b-col>
                </b-row>
            </b-card>

            <b-modal v-model=" showModal " no-close-on-backdrop no-close-on-esc size="lg">

                <div v-if=" selectedText ">

                    <div class="d-flex justify-content-between align-items-center mb-3">

                        <div>
                            <p class="small font-bold mb-0">User: {{ selectedText.recipient || ' n/a ' }}</p>
                            <p class="small font-bold mb-0">{{ formatDateTime( selectedText.created_at ) }}</p>
                        </div>
                        <div>
                            <p class="small font-bold mb-0 text-right">From: {{ phoneFormat( selectedText.from_number ) }}</p>
                            <p class="small font-bold mb-0 text-right">To: {{ phoneFormat( selectedText.to_number ) }}</p>
                        </div>
                    </div>

                    <b-alert variant="danger" class="mb-2" show v-if=" selectedText.error "><b>Error: </b>{{ selectedText.error }}</b-alert>

                    <hr />
                    <div class="my-2 py-1">

                        <h5>Message Body:</h5>
                        {{ selectedText.body }}
                    </div>

                    <div v-if=" !selectedText.recipient " class="mt-3">

                        <h5>Assign to a User:</h5>
                        <transition mode="out-in" name="slide-fade">

                            <user-role-search-dropdown v-if=" current_assigned_filter_type == 'provider' " type="provider" v-model=" assigned_user_id " style=" flex: 2"></user-role-search-dropdown>
                            <user-role-search-dropdown v-if=" current_assigned_filter_type == 'claimant' " type="claimant" v-model=" assigned_user_id " style=" flex: 2"></user-role-search-dropdown>
                        </transition>

                        <div class="d-flex align-items-center justify-content-end mt-2">

                            <b-button variant="primary" @click=" changeAssignedFilterType() " class="mr-2" :disabled=" loading ">{{ filterTypeButtonText }}</b-button>
                            <b-button variant="info" @click=" assignUser() " :disabled=" loading ">Assign User</b-button>
                        </div>
                    </div>
                </div>
                <div slot="modal-footer">

                    <b-btn variant="default" @click=" showModal = false " :disabled=" loading ">Close</b-btn>
                </div>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>

    import PaginatedTable from "../../mixins/PaginatedTable";
    import FormatsDates from "../../mixins/FormatsDates";
    import FormatsNumbers from '../../mixins/FormatsNumbers';

    export default {

        mixins: [ PaginatedTable, FormatsDates, FormatsNumbers ],
        data() {

            return {

                current_assigned_filter_type : 'claimant',
                assigned_user_id    : '',

                showModal           : false,
                selectedText        : null,
                current_filter_type : 'claimant',

                baseUrl             : '/business/text_message',

                start_date          : moment().startOf( 'isoweek' ).format( 'MM/DD/YYYY' ),
                end_date            : moment().startOf( 'isoweek' ).add( 6, 'days' ).format( 'MM/DD/YYYY' ),
                user_id             : '',
                status              : '',
                ltc_carrier_id      : '',
                special_filter      : '',

                fields : [

                    {
                        key: 'recipient',
                        label: 'Recipient',
                        sortable: true
                    },
                    {
                        key: 'carrier_initials',
                        label: 'Block',
                        sortable: true 
                    },
                    {
                        key: 'from_number',
                        label: 'From',
                        sortable: true,
                        formatter: ( val ) => ! val ? '-' : this.phoneFormat( val ),
                    },
                    {
                        key: 'to_number',
                        label: 'To',
                        sortable: true,
                        formatter: ( val ) => ! val ? '-' : this.phoneFormat( val ),
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    },
                ],
            }
        },

        computed: {

            filterTypeButtonText(){ return this.current_filter_type == 'claimant' ? 'Change Search to Providers' : 'Change Search to Claimants'; },
            appliedFilters(){ return `?ltc_carrier_id=${this.ltc_carrier_id}&start_date=${this.start_date}&end_date=${this.end_date}&user_id=${this.user_id}&special_filter=${this.special_filter}`; }
        },

        methods: {

            changeAssignedFilterType(){

                this.assigned_user_id = '';
                switch( this.current_assigned_filter_type ){

                    case 'claimant':

                        this.current_assigned_filter_type = 'provider';
                        break;
                    case 'provider':

                        this.current_assigned_filter_type = 'claimant';
                        break;
                    default:

                        this.current_assigned_filter_type = 'wtf';
                        break;
                }
            },
            changeFilterType(){

                this.user_id = '';
                switch( this.current_filter_type ){

                    case 'claimant':

                        this.current_filter_type = 'provider';
                        break;
                    case 'provider':

                        this.current_filter_type = 'claimant';
                        break;
                    default:

                        this.current_filter_type = 'wtf';
                        break;
                }
            },
            selectText( text ){

                this.selectedText = text;
                this.showModal = true;
            },
            assignUser(){

                if( !this.selectedText.id ) return;

                this.loading = true;
                let form = new Form({ user_id : this.assigned_user_id });
                form.patch( `${this.baseUrl}/${this.selectedText.id}` )
                    .then( res => {

                        this.showModal = false;
                    })
                    .finally( () => {

                        this.loading = false;
                        this.loadTable();
                    });
            }
        }
    }
</script>

<style>

</style>